import axios from "axios";

$(function () {
    // console.log('c-ymd', $('.c-ymd').length, $('.c-ymd'));
    // console.log('c-ym', $('.c-ym').length, $('.c-ym'));
    if (0 < $('.c-ymd')?.not('.hasDatepicker')?.length) {
        axios
        .get('/system-setting/MAX_DEADLINE_DAY')
        .then(res => {
            $('.c-ymd')?.datepicker({
                onSelect: function () {
                    var e = document.createEvent('HTMLEvents');
                    e.initEvent('input', false, true);
                    this.dispatchEvent(e);
                },
                minDate: '+1d',
                maxDate: `+${res.data.value}d`,
            });
        });
       
    }

    if (0 < $('.c-ym')?.length) {
        $('.c-ym')?.datepicker({
            showOnlyMonths: true,
            dateFormat: 'yy/mm',
            onSelect: function () {
                var e = document.createEvent('HTMLEvents');
                e.initEvent('input', false, true);
                this.dispatchEvent(e);
            },
        });
    }

    if (0 < $('.js-reward-datepicker')?.not('.hasDatepicker')?.length) {
        $('.js-reward-datepicker')?.datepicker({
            onSelect: function () {
                var e = document.createEvent('HTMLEvents');
                e.initEvent('input', false, true);
                this.dispatchEvent(e);
            },
        });
    }
});
